import { LayaGL } from "../../layagl/LayaGL";
import { Color } from "../../maths/Color";
import { Matrix } from "../../maths/Matrix";
import { Vector2 } from "../../maths/Vector2";
import { Vector4 } from "../../maths/Vector4";
import { RenderTargetFormat } from "../../RenderEngine/RenderEnum/RenderTargetFormat";
import { Material } from "../../resource/Material";
import { RenderTexture2D } from "../../resource/RenderTexture2D";
import { ClassUtils } from "../../utils/ClassUtils";
import { PostProcess2DEffect } from "../PostProcess2DEffect";
import { Blit2DCMD } from "../Scene2DSpecial/RenderCMD2D/Blit2DCMD";
var _definiteIntegralMap = {};
export class BlurEffect2D extends PostProcess2DEffect {
    get shaderV1() {
        return this._shaderV1;
    }
    set shaderV1(value) {
        if (value != this._shaderV1) {
            value.cloneTo(this._shaderV1);
        }
        this._mat && this._mat.setVector4("u_strength_sig2_2sig2_gauss1", this._shaderV1);
        this._owner && this._owner._onChangeRender();
    }
    constructor(strength) {
        super();
        this._centerScale = new Vector2();
        this._shaderV1 = new Vector4();
        this._blurInfo = new Vector2();
        this._shaderV1 = new Vector4();
        this.strength = strength !== null && strength !== void 0 ? strength : 4;
    }
    effectInit(postprocess) {
        this._owner = postprocess;
        (!this._mat) && (this._mat = new Material());
        this._mat.setShaderName("BlurEffect2D");
        if (!this._renderElement) {
            this._renderElement = LayaGL.render2DRenderPassFactory.createRenderElement2D();
            this._renderElement.geometry = Blit2DCMD.InvertQuadGeometry;
            this._renderElement.nodeCommonMap = null;
            this._renderElement.renderStateIsBySprite = false;
            this._renderElement.materialShaderData = this._mat.shaderData;
            this._renderElement.subShader = this._mat.shader.getSubShaderAt(0);
        }
        this._mat.setVector4("u_strength_sig2_2sig2_gauss1", this._shaderV1);
        this._mat.setVector2("u_centerScale", this._centerScale);
        this._mat.lock = true;
    }
    render(context) {
        let marginLeft = 50;
        let marginTop = 50;
        let width = context.indirectTarget.width;
        let height = context.indirectTarget.height;
        let texwidth = width + 2 * marginLeft;
        let texheight = height + 2 * marginTop;
        this._blurInfo.setValue(texwidth, texheight);
        if (!this._destRT || this._destRT.width != texwidth || this._destRT.height != texheight) {
            if (this._destRT)
                this._destRT.destroy();
            this._destRT = new RenderTexture2D(texwidth, texheight, RenderTargetFormat.R8G8B8A8);
        }
        this._centerScale.setValue(width / texwidth, height / texheight);
        this._mat.setVector2("u_centerScale", this._centerScale);
        this._mat.setVector2("u_blurInfo", this._blurInfo);
        this._mat.setTexture("u_MainTex", context.indirectTarget);
        context.command.setRenderTarget(this._destRT, true, Color.CLEAR);
        context.command.drawRenderElement(this._renderElement, Matrix.EMPTY);
        context.destination = this._destRT;
    }
    get strength() {
        return this._strength;
    }
    set strength(v) {
        if (v == this._strength)
            return;
        this._strength = Math.max(Math.abs(v), 2);
        var sigma = this._strength / 3.0;
        var sigma2 = sigma * sigma;
        let v1 = this._shaderV1.setValue(this.strength, sigma2, 2.0 * sigma2, 1.0 / (2.0 * Math.PI * sigma2));
        let s = 0;
        let key = Math.floor(this.strength * 10);
        if (_definiteIntegralMap[key] != undefined) {
            s = _definiteIntegralMap[key];
        }
        else {
            for (let y = -4; y <= 4; ++y) {
                for (let x = -4; x <= 4; ++x) {
                    s += v1.w * Math.exp(-(x * x + y * y) / v1.z);
                }
            }
            _definiteIntegralMap[key] = s;
        }
        v1.w /= s;
        this.shaderV1 = v1;
    }
    destroy() {
        var _a;
        this._destRT && this._destRT.destroy();
        this._mat.destroy();
        this._mat = null;
        (_a = this._renderElement) === null || _a === void 0 ? void 0 : _a.destroy();
        this._renderElement = null;
    }
}
ClassUtils.regClass("BlurEffect2D", BlurEffect2D);
